import {DomainObject} from 'shared/DomainObject';
import { observable, makeObservable } from 'mobx';

class Department extends DomainObject {
  id;
  name;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable
    });

    this.merge(other);
  }

  static defaultOrderAttribute() {
    return 'name';
  }
}

export default Department;

